<template>
  <div :class="{index:body_bg}" v-if="body_show">
    <div v-if="!data.label" class="prom_person">
      <h2>欢迎申请成为人才加速器推广大使<br/>
添加下方二维码联系推广大使小助手</h2>
      <img src="@a/details_new.png" alt="" />
      <p>( 长按识别或扫描上方二维码添加 )</p>
    </div>
    <!-- 推广活动 -->
    <div v-else>
      <div class="prom_list clearfix" v-if="data.event">
        <ul>
          <li v-for="(item,index) in list" :key="index">
            <h2>
              <b>{{item.name}}</b>
              <span>进行中</span>
          </h2>
            <div class="course clearfix">
              <img :src="item.promotionimg" alt="" />
              <div class="course_fg">
                <h3>学员优惠金额：￥ {{item.discount}}</h3>
                <h3>返佣金额：<span><span>￥</span>{{item.brokerage}}</span></h3>
              </div>
            </div>
            <div class="copy text-ellipsis">
              专属链接：{{item.url}}
            </div>
            <div class="href">
              <a class="copy_a" v-clipboard:copy="item.url" v-clipboard:success="onCopy" v-clipboard:error="onError">复制链接</a>
              <router-link :to="'/promotion_list?id='+ item.id">我的推广</router-link>
            </div>
          </li>
        </ul>
      </div>
      <img src="@a/pro_null.png" class="cer_img" v-else/>
    </div>
  </div>
</template>
<script>
import {
  promotionList
} from "@/api/person"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        data: {},
        list: [],
        body_bg: false
      }
    },
    methods: {
      // 初始化获取数据函数
      pullData() {
        promotionList()
          .then(data => {
            this.body_show = true;
            this.data = data;
            this.list = data.list;
            this.body_bg = !data.event;
          });
      },
      // 复制成功
      onCopy(e) {
        this.$toast('复制成功');
      },
      // 复制失败
      onError(e) {
        alert("失败");
      },
    },
    created() {
      this.pullData();
      shareCon("index", this);
    }
}
</script>
<style lang="scss" scoped>
.index {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #fff;
  font-size: 0;
}

.prom_person {
  padding-top: 160px;
  text-align: center;
  h2 {
    font-size: 32px;
    color: #EB5032;
    line-height: 48px;
  }
  img {
    width: 426px;
    margin-top: 90px;
  }
  p {
    color: #999;
    font-size: 28px;
  }
}

.prom_list {
  padding: 0 30px;
  ul li {
    width: 100%;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    padding: 20px;
    margin-top: 20px;
    h2 {
      padding-bottom: 10px;
      border-bottom: 2px solid #ccc;
      color: #333;
      font-size: 28px;
      font-weight: bold;
      span {
        font-weight: normal;
        float: right;
        color: #EB5032;
        font-size: 24px;
        margin-top: 2px;
      }
    }
    .course {
      display: block;
      margin-top: 20px;
      position: relative;
      padding-bottom: 20px;
      border-bottom: 2px solid #ccc;
      .course_fg {
        width: 400px;
        float: left;
        margin-left: 20px;
        h3 {
          color: #333;
          font-size: 26px;
          span {
            color: #EB5032;
            font-size: 38px;
            span {
              font-size: 26px;
            }
          }
        }
        h3:last-child {
          margin-top: 10px;
        }
      }
      img {
        width: 200px;
        float: left;
      }
    }
    .copy {
      padding: 0 20px;
      background-color: #F0F0F0;
      line-height: 52px;
      width: 100%;
      font-size: 26px;
      color: #333;
      margin-top: 40px;
    }
  }
}

.href {
  margin-top: 30px;
  a {
    width: 152px;
    height: 54px;
    line-height: 52px;
    border: 2px solid rgba(235, 80, 50, 1);
    border-radius: 27px;
    color: #EB5032;
    font-size: 26px;
    display: inline-block;
    text-align: center;
  }
  .copy_a {
    background-color: #EB5032;
    color: #fff;
    margin-right: 30px;
  }
}

.cer_img {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  width: 480px;
  margin-left: -240px;
}
</style>
